
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_f8g6q_1fz2e_21",
  "embedded": "awsui_embedded_f8g6q_1fz2e_53",
  "tokens": "awsui_tokens_f8g6q_1fz2e_86",
  "dropdown-header": "awsui_dropdown-header_f8g6q_1fz2e_90",
  "dropdown-footer": "awsui_dropdown-footer_f8g6q_1fz2e_96"
};
  